var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWafAndShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#759B3E;}\r\n\t.st1{fill:#4B612C;}\r\n\t.st2{fill:#648239;}\r\n\t.st3{fill:#B6C99C;}\r\n\t.st4{fill:#3D4A2A;}\r\n\t.st5{fill:#638239;}\r\n\t.st6{fill:#3E5715;}\r\n\t.st7{fill:#6D962E;}\r\n\t.st8{fill:#4A602C;}\r\n\t.st9{fill:#749B3E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,34.9c0,6.7,0,13.4,0,20.1c0,0-0.1,0-0.1,0.1c0,0.1,0,0.1,0.1,0.2c-2.7,4.7-5.4,9.4-8.1,14.2 c-0.4,0.7-0.8,0.5-1.3,0.3c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0,0,0c-0.4-0.8-1.3-1.2-2-1.7c-3.5-2.3-7-4.5-10.5-6.9 c0-10.7,0-21.5,0-32.2c2.5-1.6,5.1-3.2,7.6-4.9c1.8-1.2,3.7-2.1,5.2-3.6c0.4-0.2,0.8-0.6,1.2,0.1c2.7,4.7,5.4,9.5,8.1,14.2 c0,0-0.1,0.1-0.1,0.1C89.9,34.8,90,34.9,90,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,69.7c-0.4,0.1-0.9,0.6-1.3-0.1c-2.7-4.8-5.4-9.5-8.2-14.3c0.3-0.3,0.2-0.7,0.2-1c0-6.2,0-12.4,0-18.6 c0-0.3,0.1-0.7-0.2-1c2.7-4.7,5.4-9.4,8.1-14.2c0.3-0.5,0.6-0.7,1.1-0.3c0.3,0.5,0.8,0.7,1.2,0.9c3.9,2.5,7.8,5.1,11.6,7.6 c0.1,10.8-0.3,21.6,0.2,32.4c-0.3,0-0.5,0.2-0.7,0.3c-3.5,2.3-7,4.5-10.5,6.8C50.5,68.8,49.8,69,49.5,69.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.8,61c3.4,2.4,6.9,4.6,10.5,6.9c0.7,0.5,1.6,0.9,2,1.7c-3.8-1.2-7.7-2.4-11.5-3.5c-1.3-0.4-2.5-0.7-3.8-1.1 c0-1.5,0-2.9,0-4.4c0,0,0.1,0,0.1,0l0.1,0C66,60.7,66.8,61.1,67.8,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.6,20.4c-1.6,1.4-3.5,2.4-5.2,3.6c-2.5,1.7-5.1,3.3-7.6,4.9c-0.9,0.2-1.7,0.4-2.6,0.7c0,0-0.1,0-0.1,0 c0-1.4,0-2.8-0.1-4.2c4.8-1.5,9.5-3,14.3-4.6C79.7,20.5,80.1,20.2,80.6,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.9,60.5c0,1.5,0,2.9,0,4.4c-5.1,1.6-10.3,3.2-15.4,4.8c0.3-0.7,1-0.9,1.6-1.3c3.5-2.3,7-4.6,10.5-6.8 c0.2-0.2,0.4-0.3,0.7-0.3C63.2,61,64.1,60.7,64.9,60.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M64.9,25.2c0,1.4,0,2.8,0.1,4.2c-1-0.2-1.9-0.4-2.9-0.7c-3.9-2.5-7.8-5.1-11.6-7.6c-0.4-0.3-0.9-0.5-1.2-0.9 c4.4,1.4,8.8,2.8,13.2,4.1C63.3,24.6,64.1,24.9,64.9,25.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.1,34.7c0.3,0.3,0.2,0.7,0.2,1c0,6.2,0,12.4,0,18.6c0,0.3,0.1,0.7-0.2,1C40,51.5,40,47.8,40,44 C40,40.9,40,37.8,40.1,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90,34.9c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0.1-0.1C90,34.8,90,34.9,90,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M90,55.3c0-0.1,0-0.1-0.1-0.2c0,0,0.1,0,0.1-0.1C90,55.1,90,55.2,90,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.2,69.6c0.1,0,0.2,0.1,0.3,0.1C80.4,69.7,80.3,69.7,80.2,69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M65.1,29.5c0.9-0.2,1.7-0.4,2.6-0.7c0,10.7,0,21.5,0,32.2c-0.9,0-1.8-0.3-2.7-0.5c0-0.5,0-0.9,0-1.4 C65.1,49.2,65.1,39.4,65.1,29.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M65.1,29.5c0,9.9,0,19.7,0,29.6c0,0.5,0,0.9,0,1.4c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c-0.9,0.2-1.7,0.5-2.6,0.7 c-0.5-10.8-0.1-21.6-0.2-32.4c1,0.2,1.9,0.4,2.9,0.7C65,29.4,65.1,29.5,65.1,29.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWafAndShield);
export default __webpack_public_path__ + "static/media/WAFAndShield.fac05cc7f58f29f69adebb887047d394.svg";
export { ForwardRef as ReactComponent };